import React from 'react'

import globalStyles from "../../../assets/styles/global.module.scss";
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import dashboardStyles from '../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';

import { customVariableDataInterface, globalMenuItemData } from '../../../models/axiosModel'
import { TableCell } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import GlobalMenu from '../../globalMenu';

interface MemoizedCustomVariableTableRowProps {
    data: customVariableDataInterface, 
    index: number, 
    anchorEl: null | SVGSVGElement, 
    currentRowIndex: string | null,
    menuItem: globalMenuItemData[]; 
    handleMenuOpen: (event: React.MouseEvent<SVGSVGElement, MouseEvent>, rowIndex: string) => void;
    handleMenuClose: () => void;   
    isMenuOpen: boolean,
} 

const MemoizedCustomVariableTableRow: React.FC<MemoizedCustomVariableTableRowProps> = React.memo((props) => {
    
    const { data, index, anchorEl, currentRowIndex, menuItem, handleMenuOpen, handleMenuClose, } = props;
    
    return (
        <>
            <TableCell 
                key={index} 
                className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${style.fieldCellWidth} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}`} 
            >
                {data?.chatbot_custom_variable_name}
            </TableCell>
            <TableCell 
                key={index} 
                className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${style.fieldCellWidth} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}`} 
            >
                {data?.chatbot_custom_variable_fallback_value ?? "-"}
            </TableCell> 
            <TableCell 
                key={index} 
                className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${style.fieldCellWidth} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}`} 
            >
                {data?.flag_archived ? "Yes" : "No"}
            </TableCell> 
            
            <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${style.lastColumnSticky} ${style.moreVertIcon} ${style.checkBoxCellWidth} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter} ${globalStyles.contentEnd}`}>
                {data?.flag_archived ? (
                    <></>
                ) : (
                    <>
                        <MoreVertIcon
                            className={globalStyles.clickable}
                            onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
                                handleMenuOpen(e, data?.chatbot_custom_variable_configuration_id);
                            }}
                        />
                        <GlobalMenu
                            anchorEl={anchorEl}
                            handleMenuClose={handleMenuClose}
                            menuItemData={menuItem}
                            open={Boolean(anchorEl) && data.chatbot_custom_variable_configuration_id === currentRowIndex}
                            additionalField={data}
                            transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                        />
                    </>
                )}
            </TableCell>
        </>
    )
}, (prev, next) => {
    return prev.data == next.data && 
            prev.isMenuOpen == next.isMenuOpen
})

export default MemoizedCustomVariableTableRow
